var map = {
	"./about-card.de-CH.json": 1484,
	"./about-card.de-DE.json": 1485,
	"./about-card.en-CA.json": 1486,
	"./about-card.en-GB.json": 1487,
	"./about-card.en-IN.json": 1488,
	"./about-card.en-ME.json": 1489,
	"./about-card.en-US.json": 1490,
	"./about-card.es-EM.json": 1491,
	"./about-card.es-ES.json": 1492,
	"./about-card.fr-BE.json": 1493,
	"./about-card.fr-CA.json": 1494,
	"./about-card.fr-CH.json": 1495,
	"./about-card.nl-BE.json": 1496,
	"./about-card.nl-NL.json": 1497,
	"./about-card.pl-PL.json": 1498,
	"./about-card.pt-BR.json": 1499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1483;